'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _Captcha = require('../../helpers/Captcha');

var _DefaultString = require('../../helpers/DefaultString');

var _PopupType = require('../../helpers/PopupType');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _MusicBusiness = require('./MusicBusiness.scss');

var _MusicBusiness2 = _interopRequireDefault(_MusicBusiness);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = require('email-validator');

var MusicBusiness = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    captcha: state.captcha,
    captchaToken: state.captcha.captchaToken,
    lang: state.auth.lang };
}, { changePopupType: _popup.changePopupType, login: _auth.login }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MusicBusiness, _Component);

  function MusicBusiness() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MusicBusiness);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MusicBusiness.__proto__ || (0, _getPrototypeOf2.default)(MusicBusiness)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      captchaError: false,
      password: '',
      username: ''
    }, _this.editCaptchaError = function (captchaError) {
      _this.setState({ captchaError: captchaError });
    }, _this.handleEnterKey = function (event) {
      if (event.key === 'Enter') {
        _this.submitLogin();
      }
    }, _this.handlePasswordChange = function (event) {
      _this.setState({ password: event.target.value });
    }, _this.handleUsernameChange = function (event) {
      _this.setState({ username: event.target.value });
    }, _this.validateEmail = function (email) {
      return validator.validate(email);
    }, _this.reCaptchaValidated = function (captchaToken) {
      if (captchaToken) {
        _this.props.login(_this.state.username, _this.state.password, _this.props.lang, _this.props.captchaToken);
      } else {
        _this.editCaptchaError(true);
      }
    }, _this.submitLogin = function () {
      if (_this.validateEmail(_this.state.username)) {
        _this.captchaEl.getWrappedInstance().executeReCaptcha();
      } else {
        _this.props.changePopupType(_PopupType.PopupId.InvalidCredentials);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MusicBusiness, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.loggingIn && !nextProps.auth.loggingIn) {
        if (nextProps.auth.loginError) {
          this.props.changePopupType(_PopupType.PopupId.InvalidCredentials);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formatMessage = this.props.intl.formatMessage;

      var hasCaptcha = this.props.captcha.needCaptcha;

      return _react2.default.createElement(
        'div',
        { className: _MusicBusiness2.default.welcomeBusiness },
        _react2.default.createElement('div', { className: _MusicBusiness2.default.background }),
        _react2.default.createElement(
          'div',
          { className: _MusicBusiness2.default.content },
          _react2.default.createElement(
            'div',
            { className: _MusicBusiness2.default.title },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.WelcomeMusicBusinessTitle)
          ),
          _react2.default.createElement(
            'div',
            {
              className: _MusicBusiness2.default.description + " " + (hasCaptcha ? _MusicBusiness2.default.needCaptcha : "")
            },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.WelcomeMusicBusinessDescription)
          ),
          _react2.default.createElement(
            'div',
            { className: _MusicBusiness2.default.enterUserNamePass },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.WelcomeMusicBusinessEnterUserNamePass)
          ),
          _react2.default.createElement(
            _reactBootstrap.Form,
            { onSubmit: this.submitLogin },
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { role: 'form' },
              _react2.default.createElement(_reactBootstrap.FormControl, {
                name: 'username',
                type: 'text',
                value: this.state.username,
                placeholder: formatMessage(_DefaultString.translations.Username),
                onChange: this.handleUsernameChange,
                onKeyPress: this.handleEnterKey
              }),
              _react2.default.createElement(_reactBootstrap.FormControl, {
                name: 'password',
                type: 'password',
                value: this.state.password,
                placeholder: formatMessage(_DefaultString.translations.Password),
                onChange: this.handlePasswordChange,
                onKeyPress: this.handleEnterKey
              }),
              _react2.default.createElement(_components.Captcha, {
                ref: function ref(el) {
                  _this2.captchaEl = el;
                },
                captchaTypeRequired: MusicBusiness.beCalls,
                error: this.state.captchaError,
                editCaptchaError: this.editCaptchaError,
                onReCaptchaValidated: this.reCaptchaValidated
              }),
              _react2.default.createElement(
                _reactBootstrap.Button,
                { className: _MusicBusiness2.default.submit, onClick: this.submitLogin },
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Login)
              )
            )
          ),
          _react2.default.createElement(_components.RememberMe, { className: _MusicBusiness2.default.rememberMe }),
          _react2.default.createElement(
            'div',
            {
              className: _MusicBusiness2.default.notSubscribe + " " + (hasCaptcha ? _MusicBusiness2.default.needCaptcha : "")
            },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.NotSubscribed)
          ),
          _react2.default.createElement(
            'div',
            { className: _MusicBusiness2.default.contactBusiness },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.ContactBusinessSale)
          )
        )
      );
    }
  }]);
  return MusicBusiness;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  captchaToken: _react.PropTypes.string,
  changePopupType: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  lang: _react.PropTypes.string,
  login: _react.PropTypes.func
}, _class2.beCalls = [_Captcha.CaptchaCallNames.Login], _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(MusicBusiness);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MusicBusiness/MusicBusiness.js
// module id = 1963
// module chunks = 0